const buttonScrollTop = document.querySelector('.button-scroll-top');
buttonScrollTop.addEventListener('click', () => {
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
});

export default buttonScrollTop;
